export enum B2C_ERROR_STATUS {
  STATUS_400 = 'AADB2C_400',
  STATUS_401 = 'AADB2C_401',
  STATUS_404 = 'AADB2C_404',
  INVALID_OLD_TOKEN_V1 = 'AADB2C90027',
  INVALID_OLD_TOKEN_V2 = 'AADB2C90075',
  INVALID_PASSWORD_SPAM = 'AADB2C90157',
}
